import { render } from "./PremiumMonthlyPromoSection.vue?vue&type=template&id=371386e0"
import script from "./PremiumMonthlyPromoSection.vue?vue&type=script&lang=js"
export * from "./PremiumMonthlyPromoSection.vue?vue&type=script&lang=js"

import "./PremiumMonthlyPromoSection.vue?vue&type=style&index=0&id=371386e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__